import { useSelector } from "react-redux";
import HashtagIcon from "assets/icons/Hashtag";
import "./fishPrint.css";
import { formatPrice } from "helpers";
import Barcode from "react-barcode";
import Logo from "assets/svg/Logo.svg";
import { useRef } from "react";
import { Phone, Web } from "@mui/icons-material";
export default function useFishPrint(props?: { factor?: Factor, secondVersion?: boolean }) {
  const secondVersion = props?.secondVersion === true
  const store = useSelector((state: any) => state);

  const factor: Factor = props?.factor || store.factorReducer?.factor;
  const settings = props?.factor || store.factorReducer?.factorPattern;
  const business = store.businessReducer.business.business;
  const contentRef = useRef<any>(null);
  const appSettings = store.appReducer?.appSettings || {};
  const {
    fishPrintDescription,
    fishPrintDisplayAddress,
    fishPrintDisplayBarcode,
    fishPrintDisplayCustomer,
    fishPrintDisplayDescription,
    fishPrintDisplayLogo,
    fishPrintDisplayPhone,
    fishPrintDisplayWebsite,
    fishPrintDisplayBranch,
    fishPrintDisplayProject,
    fishPrintDisplayMobile,
    fishPrintDisplayBuyerBalance,

  } = appSettings;

  let content = <></>;
  if (factor) {
    content = (
      <div
        className="w-[300px] bg-white flex flex-col items-center text-black p-1"
        ref={contentRef}
        style={{ direction: "rtl" }}
      >
        {fishPrintDisplayLogo && settings?.logo && (
          <div className="w-full flex justify-center items-center pb-2">
            <img src={settings.logo} alt="" className="w-20 h-20" />
          </div>
        )}
        <div className="text-base font-semibold pb-1">{business?.legalName || business?.nickName}</div>

        <div className="flex flex-col items-center py-1">
          <div className="text-xs font-semibold flex items-center gap-2">
            {fishPrintDisplayPhone && business?.phone && (
              <div className="flex items-center gap-2">
                <span>{business.phone}</span>
                <Phone className="w-3" />
              </div>
            )}
            {fishPrintDisplayWebsite && business?.webSite && (
              <div className="flex items-center gap-2">
                <span>{business.webSite}</span>
                <Web className="w-3" />
              </div>
            )}
          </div>
          {fishPrintDisplayAddress && <div className="text-xs">{business.address}</div>}
        </div>

        <div className="w-full py-2">
          <div className="border rounded-md border-black flex justify-between items-center w-full ">
            <div className="p-1 h-full flex items-center " style={{ borderLeft: "1px solid black" }}>
              <div
                className="flex justify-center items-center p-1"
                style={{ borderLeft: "1px solid black" }}
              >
                <HashtagIcon color="black" style={{ transform: "scale(0.8)" }} />
              </div>
              <span className="text-xs px-2">{factor.accountingCode}</span>
            </div>
            <div className="flex gap-2 items-center text-xs p-2">
              {/*<span>{DateToString(Date.now())}</span>*/}
              <span>{factor.time}</span>
              <span>
                {factor.date}
                {/*{Intl.DateTimeFormat("en", { hour: "numeric", minute: "numeric", hourCycle: "h24" }).format(*/}
                {/*  Date.now()*/}
                {/*)}*/}
              </span>
            </div>
          </div>
        </div>

        {fishPrintDisplayCustomer && factor.Person && (
          <div className="grid grid-cols-2 gap-2 text-xs py-2 items-start w-full">
            {factor?.Person?.nickName && (
              <div className="flex items-center gap-2">
                <span>نام مشتری:</span>
                <span className="font-semibold">{factor.Person.nickName}</span>
              </div>
            )}

            {factor.Person?.mobile && fishPrintDisplayMobile && (
              <div className="flex items-center gap-2">
                <span>موبایل:</span>
                <span className="font-semibold">{factor.Person.mobile}</span>
              </div>
            )}
            {factor.Person?.address && (
              <div className="flex items-center gap-2">
                <span>آدرس:</span>
                <span className="font-semibold">{factor.Person.address}</span>
              </div>
            )}

            {fishPrintDisplayBranch && factor.Branch && (
              <div className="flex items-center gap-2">
                <span>شعبه:</span>
                <span className="font-semibold">{factor.Branch.title}</span>
              </div>
            )}
            {fishPrintDisplayProject && factor.Project && (
              <div className="flex items-center gap-2">
                <span>پروژه:</span>
                <span className="font-semibold">{factor.Project.title}</span>
              </div>
            )}
            {fishPrintDisplayBuyerBalance && factor?.Person?.balance && (
              <div className="flex items-center gap-2">
                <span>تراز:</span>
                <span className="font-semibold" dir="ltr">
                  {formatPrice(factor.Person.balance)}
                </span>
                <span className="text-xs">{factor.Currency?.en_title}</span>
              </div>
            )}
          </div>
        )}

        <table className="text-xs border-separate border-spacing-0 border border-black rounded-md w-full fish-print-table">
          <thead>
            <th style={{ borderLeft: "none" }}>
              <HashtagIcon color="black" style={{ transform: "scale(0.7)" }} />
            </th>
            <th className="w-[140px]">نام کالا</th>
            {!secondVersion && <th style={{ borderLeft: "none" }}>قیمت کالا</th>}
            <th>تعداد</th>
            {!secondVersion && <th>قیمت کل</th>}
          </thead>
          <tbody>
            {factor.Factor_Items?.map((item, i) => {
              return (
                <tr key={i}>
                  <td className="text-center text-[11px] font-semibold">{i + 1}</td>
                  <td className="px-0 py-1">
                    <div
                      className="flex flex-col min-h-[24px] justify-center px-1"
                      style={{ borderLeft: "1px solid black" }}
                    >
                      <span className="text-xs font-semibold">{item.Product?.title}</span>
                      <span className="text-[10px]">{item.Product?.barcode}</span>
                    </div>
                  </td>
                  {!secondVersion && <td style={{ borderLeft: "none", fontSize: 11, fontWeight: "bold" }}>
                    <span className="flex justify-center">{formatPrice(item.price)}</span>
                  </td>
                  }
                  <td className="px-0 py-1">
                    <div
                      className="flex flex-col min-h-[24px] justify-center"
                      style={{ borderLeft: "1px solid black" }}
                    >
                      <span className="flex flex-col justify-center items-center px-1 relative">
                        <span className="text-[10px] font-semibold -mb-1">{item.quantity}</span>
                        <span className="text-[8px] -mt-1">{item.unit}</span>
                      </span>
                    </div>
                  </td>
                  {!secondVersion && <td className="text-[11px] font-semibold">{formatPrice(item.finalPrice)}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="py-2 w-full flex flex-row-reverse text-xs">
          {!secondVersion && <div className="w-3/5 flex flex-col gap-2">
            <div className="flex justify-between items-center">
              <span>مجموع</span>
              <span className="text-[11px]">{formatPrice(factor.total)}</span>
            </div>
            <div className="flex justify-between items-center">
              <span>تخفیف</span>
              <span className="text-[11px]">{formatPrice(factor.totalDiscount)}</span>
            </div>
            {!!factor.totalTax && (
              <div className="flex justify-between items-center">
                <span>مالیات</span>
                <span className="text-[11px]">{formatPrice(factor.totalTax)}</span>
              </div>
            )}
            {!!factor.transferPrice && (
              <div className="flex justify-between items-center">
                <span>حمل و نقل</span>
                <span className="text-[11px]">{formatPrice(factor.transferPrice)}</span>
              </div>
            )}
            <div className="flex justify-between items-start mt-4">
              <span className="text-[11px] font-semibold ">قابل پرداخت</span>
              <div className="flex flex-col items-end">
                <span className="text-sm font-semibold">{formatPrice(factor.totalPrice)}</span>
                <span className="text-xs">{factor.Currency?.en_title}</span>
              </div>
            </div>
          </div>
          }
        </div>

        {fishPrintDisplayDescription && (
          <div className="text-xs flex gap-1 w-full">
            <span>توضیحات:</span>
            <span>{
              settings.description ||
              fishPrintDescription}</span>
          </div>
        )}

        {fishPrintDisplayBarcode && (
          <div className="py-2 w-full flex justify-center items-center">
            <Barcode value={`${factor.id}`} height={50} width={5} />
          </div>
        )}

        <div
          className="w-full flex justify-between relative py-2 mt-6"
          style={{ borderTop: "1px solid black" }}
        >
          <div className="bg-white px-4 h-6 absolute -top-3 left-28">
            <img src={Logo} alt="" width={24} height={24} />
          </div>
          <div className="text-[11px]">حسابداری ابری چرتکه</div>
          <div className="text-sm">www.chortke.app</div>
        </div>
      </div>
    );
  }
  return { content, contentRef };
}
